var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"zov-long-list",on:{"scroll":_vm.update}},[_c('div',{style:(_vm.listStyle)},[_vm._l((_vm.list),function(item,index){return _vm._t("default",null,{"props":{ item: item, index: _vm.sI + index }})})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }